module.exports = __webpack_public_path__ + "20f4414a78404f329a4c305e8bd357eb.png";